import styled from 'styled-components';

import { basicBodyTextStyle } from '@dreryk/react-components';

export const StyledEmergencyNotificationContent = styled.div`
   ${basicBodyTextStyle};
   display: flex;
   flex-direction: column;
   gap: 12px;
   min-width: 166px;
   max-width: 292px;
   align-items: center;
`;

StyledEmergencyNotificationContent.displayName = 'StyledEmergencyNotificationContent';
